module.exports = __webpack_public_path__ + "static/media/icon-sent--blue.693a7612.svg";